import { Layout, Row, Col } from 'antd';
import {
  UnorderedListOutlined,
  SettingOutlined,
  QrcodeOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import BlockWidget from './BlockWidget';

const { Content } = Layout;
const HomePage = () => {
  const { t } = useTranslation();
  return (
    <Content>
      <Row>
        <Col xs={24} sm={12} lg={8}>
          <BlockWidget
            name={t('routeName.QR')}
            href='/generate-qr-code'
            icon={<QrcodeOutlined />}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <BlockWidget
            name={t('routeName.transactionHistory')}
            href='/transaction-history'
            icon={<UnorderedListOutlined />}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <BlockWidget
            name={t('changeOnlineHours')}
            href='/setting'
            icon={<SettingOutlined />}
            spinOnHover
          />
        </Col>
      </Row>
    </Content>
  );
};

export default HomePage;
